import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import CloseIcon from "@mui/icons-material/Close";

function LogoutDialog({ open, handleAgree, setOpen }) {
  const handleCloseDialog = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle
        sx={{
          p: "12px 24px",
          borderBottom: "1px solid #dee2e6",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h3
          style={{
            color: "#1A202C",
            marginBottom: 0,
            fontWeight: 600,
          }}
        >
          Logout
        </h3>
        <IconButton size="small" onClick={handleCloseDialog}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className="pt-3" sx={{ p: 3 }}>
        <p
          style={{
            marginBottom: 0,
          }}
        >
          Are you sure you want to logout? You will need to sign in again to
          continue.
        </p>
      </DialogContent>

      <DialogActions sx={{ p: "12px 24px", borderTop: "1px solid #dee2e6" }}>
        <Button
          variant="outlined"
          onClick={handleCloseDialog}
          sx={{
            color: "#405066ff",
            borderColor: "#ced5deff",
            "&:hover": {
              borderColor: "#b0bfd1ff",
              backgroundColor: "#F8FAFC",
            },
          }}
        >
          Cancel
        </Button>

        <Button variant="contained" color="error" onClick={handleAgree}>
          Log Out
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default LogoutDialog;
